/** Events / testimonials / home CMS. Off = static site content only. */
export const cmsEnabled = process.env.NEXT_PUBLIC_CMS_ENABLED === "true";
